import { ComponentProps } from 'react'
import { useTranslations } from '@/lib/next-shim'
import clsx from 'clsx'
import LinkButton from '@/components/external/material/LinkButton'

export function ConsultNowButton({
  className,
  meetingLinkSlug,
  ...rest
}: Omit<ComponentProps<typeof LinkButton>, 'href'> & { className?: string; meetingLinkSlug: string }) {
  const t = useTranslations()
  return (
    <LinkButton
      {...rest}
      className={clsx('py-3 rounded-md text-base transition-colors', className)}
      disableElevation
      href={`/meeting-links/${meetingLinkSlug}/booking?immediate=true`}
      variant="outlined"
      color="primary"
    >
      {t('button.consultNow.label')}
    </LinkButton>
  )
}

export default ConsultNowButton
